import React from "react";
import { useTranslation } from "react-i18next";

export const languageOptions = [
    { code: "ru", label: "Русский", flag: "/flags/ru.svg" },
    { code: "en", label: "English", flag: "/flags/en.svg" },
    { code: "pt", label: "Português", flag: "/flags/pt.svg" },
    { code: "am", label: "Armenian", flag: "/flags/am.svg" },
    { code: "be", label: "Беларускі", flag: "/flags/be.svg" },
    { code: "tr", label: "Türkçe", flag: "/flags/tr.svg" },
    { code: "kz", label: "Kазақша", flag: "/flags/kz.svg" },
    { code: "az", label: "Azərbaycan", flag: "/flags/az.svg" },
];

export const getFlagFile = (lang) => {
    switch (lang) {
        case "ru": return "/flags/ru.svg";
        case "en": return "/flags/en.svg";
        case "pt": return "/flags/pt.svg";
        case "am": return "/flags/am.svg";
        case "be": return "/flags/be.svg";
        case "tr": return "/flags/tr.svg";
        case "kz": return "/flags/kz.svg";
        case "az": return "/flags/az.svg";
        default: return "/flags/en.svg";
    }
};

const LangDropdownList = ({
    currentLang,
    onSelect,
    onClose,
    dropdownClassName = "footer-lang-dropdown-list",
    headerClassName = "footer-lang-dropdown-header",
    scrollClassName = "footer-lang-dropdown-scroll",
    itemClassName = "footer-lang-dropdown-item",
    closeClassName = "footer-lang-dropdown-close",
    label = "Выберите язык",
    style,
    dropdownAlign = "right",
    innerRef,
}) => {
    const { i18n } = useTranslation();
    const lang = currentLang || i18n.language;
    return (
        <div ref={innerRef} className={dropdownClassName} style={{ ...(dropdownAlign === "left" ? { left: 0, right: 'auto' } : { right: 0, left: 'auto' }), transform: 'translateX(-30%)', ...style }}>
            <div className={headerClassName}>
                <span>{label}</span>
                <button className={closeClassName} onClick={onClose} aria-label="Закрыть">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="12" fill="#23232e" />
                        <path d="M16 8L8 16" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                        <path d="M8 8L16 16" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </button>
            </div>
            <div className={scrollClassName}>
                {languageOptions.map(option => (
                    <div
                        key={option.code}
                        className={itemClassName + (option.code === lang ? ' selected' : '')}
                        onClick={() => onSelect(option.code)}
                    >
                        <img src={option.flag} alt={option.code} className="lang-flag" />
                        <span>{option.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LangDropdownList; 